const shapeAspectRatioUtils = {
    isShift: true,

    checkShift(event) {
        return; // keep aspect ratio

        if (event.shiftKey == true)
            this.isShift = true;
        else
            this.isShift = false;
    }
};

export default shapeAspectRatioUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ShapeAspectRatioUtils.js
 **/